export class ChartSessionsPartition {
  current_partition: number;
  partitions: number;
  messages_list: any = [];
}
